/**
 * @fileoverview æ¤­åçä¸äºè®¡ç®ï¼
 *  - å¨é¿è®¡ç®åèï¼https://www.mathsisfun.com/geometry/ellipse-perimeter.html
 *  - è·ç¦»è®¡ç®åèï¼https://wet-robots.ghost.io/simple-method-for-distance-to-ellipse/
 * @author dxq613@gmail.com
 */
import { distance, piMod } from './util';
function copysign(v1, v2) {
    var absv = Math.abs(v1);
    return v2 > 0 ? absv : absv * -1;
}
export default {
    /**
     * åå´çè®¡ç®
     * @param {number} x  æ¤­åä¸­å¿ x
     * @param {number} y  æ¤­åä¸­å¿ y
     * @param {number} rx æ¤­å x æ¹ååå¾
     * @param {number} ry æ¤­å y æ¹ååå¾
     * @return {object} åå´ç
     */
    box: function (x, y, rx, ry) {
        return {
            x: x - rx,
            y: y - ry,
            width: rx * 2,
            height: ry * 2,
        };
    },
    /**
     * è®¡ç®å¨é¿ï¼ä½¿ç¨è¿ä¼¼æ³
     * @param {number} x  æ¤­åä¸­å¿ x
     * @param {number} y  æ¤­åä¸­å¿ y
     * @param {number} rx æ¤­å x æ¹ååå¾
     * @param {number} ry æ¤­å y æ¹ååå¾
     * @return {number} æ¤­åå¨é¿
     */
    length: function (x, y, rx, ry) {
        return Math.PI * (3 * (rx + ry) - Math.sqrt((3 * rx + ry) * (rx + 3 * ry)));
    },
    /**
     * è·ç¦»æ¤­åæè¿çç¹
     * @param {number} x  æ¤­åä¸­å¿ x
     * @param {number} y  æ¤­åä¸­å¿ y
     * @param {number} rx æ¤­å x æ¹ååå¾
     * @param {number} ry æ¤­å y æ¹ååå¾
     * @param {number} x0  æå®çç¹ x
     * @param {number} y0  æå®çç¹ y
     * @return {object} æ¤­åä¸è·ç¦»æå®ç¹æè¿çç¹
     */
    nearestPoint: function (x, y, rx, ry, x0, y0) {
        var a = rx;
        var b = ry;
        // åå¦æ¤­ååå¾ä¸º0åè¿ååå¿
        if (a === 0 || b === 0) {
            return {
                x: x,
                y: y,
            };
        }
        // è½¬æ¢æ 0ï¼ 0 ä¸ºä¸­å¿çæ¤­åè®¡ç®
        var relativeX = x0 - x;
        var relativeY = y0 - y;
        var px = Math.abs(relativeX);
        var py = Math.abs(relativeY);
        var squareA = a * a;
        var squareB = b * b;
        // const angle0 = Math.atan2(relativeY, relativeX);
        var t = Math.PI / 4;
        var nearestX; // æ¤­åä¸çä»»ä¸ç¹
        var nearestY;
        // è¿­ä»£ 4 æ¬¡
        for (var i = 0; i < 4; i++) {
            nearestX = a * Math.cos(t);
            nearestY = b * Math.sin(t);
            var ex = ((squareA - squareB) * Math.pow(Math.cos(t), 3)) / a;
            var ey = ((squareB - squareA) * Math.pow(Math.sin(t), 3)) / b;
            var rx1 = nearestX - ex;
            var ry1 = nearestY - ey;
            var qx = px - ex;
            var qy = py - ey;
            var r = Math.hypot(ry1, rx1);
            var q = Math.hypot(qy, qx);
            var delta_c = r * Math.asin((rx1 * qy - ry1 * qx) / (r * q));
            var delta_t = delta_c / Math.sqrt(squareA + squareB - nearestX * nearestX - nearestY * nearestY);
            t += delta_t;
            t = Math.min(Math.PI / 2, Math.max(0, t));
        }
        return {
            x: x + copysign(nearestX, relativeX),
            y: y + copysign(nearestY, relativeY),
        };
    },
    /**
     * ç¹å°æ¤­åæè¿çè·ç¦»
     * @param {number} x  æ¤­åä¸­å¿ x
     * @param {number} y  æ¤­åä¸­å¿ y
     * @param {number} rx æ¤­å x æ¹ååå¾
     * @param {number} ry æ¤­å y æ¹ååå¾
     * @param {number} x0  æå®çç¹ x
     * @param {number} y0  æå®çç¹ y
     * @return {number} ç¹å°æ¤­åçè·ç¦»
     */
    pointDistance: function (x, y, rx, ry, x0, y0) {
        var nearestPoint = this.nearestPoint(x, y, rx, ry, x0, y0);
        return distance(nearestPoint.x, nearestPoint.y, x0, y0);
    },
    /**
     * æ ¹æ®æ¯ä¾è·åç¹
     * @param {number} x æ¤­åä¸­å¿ x
     * @param {number} y æ¤­åä¸­å¿ y
     * @param {number} rx æ¤­å x æ¹ååå¾
     * @param {number} ry æ¤­å y æ¹ååå¾
     * @param {number} t æå®æ¯ä¾ï¼xè½´æ¹åä¸º 0
     * @return {object} ç¹
     */
    pointAt: function (x, y, rx, ry, t) {
        var angle = 2 * Math.PI * t; // æç§è§åº¦è¿è¡è®¡ç®ï¼èä¸æç§å¨é¿è®¡ç®
        return {
            x: x + rx * Math.cos(angle),
            y: y + ry * Math.sin(angle),
        };
    },
    /**
     * æ ¹æ®æ¯ä¾è®¡ç®åçº¿è§åº¦
     * @param {number} x æ¤­åä¸­å¿ x
     * @param {number} y æ¤­åä¸­å¿ y
     * @param {number} rx æ¤­å x æ¹ååå¾
     * @param {number} ry æ¤­å y æ¹ååå¾
     * @param {number} t æå®æ¯ä¾ 0 - 1 ä¹é´ï¼xè½´æ¹åä¸º 0ãå¨ 0-1 èå´ä¹å¤æ¯å¾ªç¯è¿æ¯è¿å nullï¼è¿éè¦è°æ´
     * @return {number} è§åº¦ï¼å¨ 0 - 2PI ä¹é´
     */
    tangentAngle: function (x, y, rx, ry, t) {
        var angle = 2 * Math.PI * t; // æç§è§åº¦è¿è¡è®¡ç®ï¼èä¸æç§å¨é¿è®¡ç®
        // ç´æ¥ä½¿ç¨ x,y çå¯¼æ°è®¡ç®ï¼ x' = -rx * sin(t); y' = ry * cos(t);
        var tangentAngle = Math.atan2(ry * Math.cos(angle), -rx * Math.sin(angle));
        // ä¹å¯ä»¥ä½¿ç¨æå®ç¹çåçº¿æ¹ç¨è®¡ç®ï¼ææ¬æäºé«
        // const point = this.pointAt(0, 0, rx, ry, t); // æ¤­åçåçº¿åæ¤­åçä¸­å¿ä¸ç¸å³
        // let tangentAngle = -1 * Math.atan((ry * ry * point.x) / (rx * rx * point.y));
        // if (angle >= 0 && angle <= Math.PI) {
        //   tangentAngle += Math.PI;
        // }
        return piMod(tangentAngle);
    },
};
//# sourceMappingURL=ellipse.js.map